module.exports = __webpack_public_path__ + "sciezka2.png?2e826d2c0b8d17264cecb9a4f75b37b9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sciezka2.png
// module id = 28
// module chunks = 0